import { Accordion } from '@prosolve/common-components-ui'
import AccountSelector from './AccountSelector';
import ImplementationSelector from './ImplementationSelector';
import ClassSelector from './ClassSelector';
import TeamSelector from './TeamSelector';

export default ({
  formData,
  singleAccountOnly,
  restrictedToOwnedClasses
}) => {
  return (
    <div>
        <Accordion
          title={
            <div>
              <div
                style={{ 
                  textDecoration: 'underline', 
                  color: '#44ACE1', 
                  fontSize: '15px', 
                  fontStyle: 'italic',
                  textAlign: 'right',
                  marginRight: '10px'
                }}
              >
                {'Filters'}
              </div>
              {/* {
                hasFilters() &&
                <span style={{
                  textDecoration: 'none',
                  marginLeft: '20px',
                  color: '#b1b5c4',
                  fontSize: '12px', 
                  fontStyle: 'italic' 
                }}>
                  {'*Filters currently applied'}
                </span>
              } */}
            </div>
          }
          defaultOpen={true}
          headerExpands={true}
          style={{ padding: '0px 5px 0px 5px', position: 'relative', top: '-20px' }}
          expandedStyle={{ padding: '20px 10px 20px 10px', marginTop: '-20px' }}
        >
          <div style={{ 
            display: 'flex',
            gap: '20px'
          }}>
            { !singleAccountOnly &&
              <AccountSelector formData={formData} />
            }
            <ImplementationSelector formData={formData} />
            <ClassSelector formData={formData} restrictedToOwnedClasses={restrictedToOwnedClasses} />
            <TeamSelector formData={formData} />
          </div>
        </Accordion>
    </div>
  )
}